import { MetadataKeynameEnum, validateIf } from '@pristine-ts/class-validator';
import { translationBaseKey } from '../../../../decorators/translation-base-key.decorator';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { SalaryContributionsOptions } from '../../salary-contributions/salary-contributions.options';

@translationBaseKey('salary-contributions-in-salary-dividend-options')
export class SalaryContributionsOptionsInSalaryDividendOptions implements Omit<SalaryContributionsOptions,
  'calculationKeyname' |
  'employmentIncome' |
  'birthdate' |
  'isTaxpayerDead' |
  'deathdate' |
  'shouldQPPBeCalculated' |
  'shouldQPIPBeCalculated' |
  'shouldEIBeCalculated' |
  'isEmployeeSubjectToEI' |
  'employmentIncomeForEI' |
  'fiscalYear'
> {
  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'totalPayroll', [
    MetadataKeynameEnum.Condition,
  ])
  @validateIf((object: SalaryContributionsOptionsInSalaryDividendOptions, root, currentPath): boolean => {
    return object.shouldFSSBeCalculated === true;
  })
  totalPayroll?: number;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'totalPayrollForPrimarySector', [
    MetadataKeynameEnum.Condition,
  ])
  @validateIf((object: SalaryContributionsOptionsInSalaryDividendOptions, root, currentPath): boolean => {
    return object.shouldFSSBeCalculated === true;
  })
  totalPayrollForPrimarySector?: number;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'isEmployerFromPublicSector', [
    MetadataKeynameEnum.Condition,
  ])
  @validateIf((object: SalaryContributionsOptionsInSalaryDividendOptions, root, currentPath): boolean => {
    return object.shouldFSSBeCalculated === true;
  })
  isEmployerFromPublicSector?: boolean;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'recurringPaymentRate', [
    MetadataKeynameEnum.Condition,
  ])
  @validateIf((object: SalaryContributionsOptionsInSalaryDividendOptions, root, currentPath): boolean => {
    return object.shouldCNESSTBeCalculated === true;
  })
  recurringPaymentRate?: number;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'shouldFSSBeCalculated')
  shouldFSSBeCalculated: boolean;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'shouldCNTBeCalculated')
  shouldCNTBeCalculated: boolean;

  @clonePropertyMetadata<SalaryContributionsOptions>(SalaryContributionsOptions, 'shouldCNESSTBeCalculated')
  shouldCNESSTBeCalculated: boolean;
}
